var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks';
import { Box, Grid, Typography } from '@mui/material';
import { InputFields } from 'common/InputFields';
import ShowHyphen from 'common/ShowHyphen/ShowHyphen';
import UserName from 'common/UserName';
import { getSeniorCareGiver, getWellnessPlan } from './SeniorWellnessPlan.action';
import { seniorWellnessInfoStyle } from './SeniorWellnessInfo.style';
import clsx from 'clsx';
import { getPaginationDataIsolated } from 'store/commonReducer/common.action';
import { getAllGoalsData, getGoalsFail, getGoalsSuccess, } from 'store/goals/goals.action';
import { PAGINATION_LIMIT } from 'globals/global.constants';
var SeniorWellnessInfo = React.memo(function (_a) {
    var _b;
    var selectedSeniorCareGiver = _a.selectedSeniorCareGiver, setSelectedSeniorCareGiver = _a.setSelectedSeniorCareGiver;
    var classes = seniorWellnessInfoStyle().classes;
    var dispatch = useAppDispatch();
    var _c = useAppSelector(function (state) { return state.common.seniorDetail.minimalInfo; }), user_id = _c.user_id, name = _c.name;
    var wellnessPlan = useAppSelector(function (state) { return state.wellnessPlan; });
    var _d = React.useState([]), seniorCareGiver = _d[0], setSeniorCareGiver = _d[1];
    var _e = React.useState(''), selectedVersion = _e[0], setSelectedVersion = _e[1];
    React.useEffect(function () {
        if (user_id) {
            getMenuItems();
        }
    }, [user_id]);
    React.useEffect(function () {
        setSelectedVersion(wellnessPlan.currentVersion);
    }, [wellnessPlan]);
    var getMenuItems = function () { return __awaiter(void 0, void 0, void 0, function () {
        var list, savedSelection, seniorToSet, parsed_1, exists;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(getSeniorCareGiver())];
                case 1:
                    list = _a.sent();
                    savedSelection = localStorage.getItem('selectedSeniorCareGiver');
                    if (savedSelection) {
                        try {
                            parsed_1 = JSON.parse(savedSelection);
                            exists = list.find(function (item) { return item.value === parsed_1.value; });
                            seniorToSet = exists || list[0]; // Use saved if exists, otherwise default
                        }
                        catch (e) {
                            seniorToSet = list[0]; // Fallback if JSON parsing fails
                        }
                    }
                    else {
                        seniorToSet = list[0]; // No saved selection, use default
                    }
                    // const senior = list[0];
                    setSeniorCareGiver(list);
                    setSelectedSeniorCareGiver(seniorToSet);
                    localStorage.setItem('selectedSeniorCareGiver', JSON.stringify(seniorToSet));
                    return [2 /*return*/];
            }
        });
    }); };
    var getVersionList = function () {
        var versionList = [];
        var lastVersion = wellnessPlan.lastAvailableVersion;
        while (lastVersion > 0) {
            versionList.push({ value: lastVersion, label: "Version ".concat(lastVersion) });
            lastVersion--;
        }
        return versionList;
    };
    var handleVersionChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var value;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    value = e.target.value;
                    return [4 /*yield*/, dispatch(getWellnessPlan(selectedSeniorCareGiver.value, value))];
                case 1:
                    _a.sent();
                    dispatch(getPaginationDataIsolated(function () { return getAllGoalsData(selectedSeniorCareGiver.value, value, undefined, 'all'); }, PAGINATION_LIMIT.goals, '', 1, getGoalsSuccess, getGoalsFail, '', ''));
                    setSelectedVersion(value);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleCGChange = React.useCallback(function (e) {
        var newValue = e.target.value;
        if (newValue) {
            var senior = seniorCareGiver.find(function (senior) { return (senior === null || senior === void 0 ? void 0 : senior.value) === newValue; });
            setSelectedSeniorCareGiver(senior);
            localStorage.setItem('selectedSeniorCareGiver', JSON.stringify(senior));
        }
    }, [seniorCareGiver, setSelectedSeniorCareGiver]);
    // const handleCGChange = React.useCallback(
    //   (e: any) => {
    //     const newValue = e.target.value;
    //     if (newValue) {
    //       const senior = seniorCareGiver.find(
    //         (senior: any) => senior?.value === newValue,
    //       );
    //       setSelectedSeniorCareGiver(senior);
    //     }
    //   },
    //   [seniorCareGiver, setSelectedSeniorCareGiver],
    // );
    return (_jsx(Box, { className: classes.seniorWellnessInfoContainer, children: _jsxs(Grid, { container: true, rowSpacing: 2, columnSpacing: 5, justifyContent: 'space-between', alignItems: 'center', children: [_jsx(Details, { firstLabel: 'Senior / Caregiver', firstValue: _jsx(Box, { className: classes.selectWidth, children: _jsx(InputFields, { menu: true, menuItems: seniorCareGiver, inputProps: { name: 'senior-caregiver' }, initialValue: '', eventProps: {
                                disabled: false,
                                onChange: handleCGChange,
                                value: selectedSeniorCareGiver.value,
                            } }) }), secondLabel: 'Wellness Plan Date Started', secondValue: _jsx(Box, { style: { color: wellnessPlan.dateStarted ? '#000' : '#a7a7a7' }, children: wellnessPlan.dateStarted || 'MM/DD/YYYY' }) }), _jsx(Details, { firstLabel: 'Last Updated by', firstValue: _jsx(Box, { style: {
                            color: wellnessPlan.lastUpdatedBy ? '#000' : '#a7a7a7',
                        }, children: wellnessPlan.lastUpdatedBy || 'Care Agent Name' }), secondLabel: 'Member Name', secondValue: _jsx(Box, { children: _jsx(ShowHyphen, { children: _jsx(UserName, { name: ((_b = selectedSeniorCareGiver === null || selectedSeniorCareGiver === void 0 ? void 0 : selectedSeniorCareGiver.data) === null || _b === void 0 ? void 0 : _b.name) || {
                                    firstName: name.first_name,
                                    middleName: name.middle_name,
                                    lastName: name.last_name,
                                } }) }) }) }), _jsx(Details, { firstLabel: 'Last Updated Date', firstValue: _jsx(Box, { style: {
                            color: wellnessPlan.lastUpdatedDate ? '#000' : '#a7a7a7',
                        }, children: wellnessPlan.lastUpdatedDate || 'MM/DD/YYYY' }) })] }) }));
});
export var Details = function (_a) {
    var _b;
    var firstLabel = _a.firstLabel, secondLabel = _a.secondLabel, firstValue = _a.firstValue, secondValue = _a.secondValue, firstLabelWidth = _a.firstLabelWidth, secondLabelWidth = _a.secondLabelWidth;
    var classes = seniorWellnessInfoStyle().classes;
    return (_jsxs(Grid, { item: true, xs: 12, sm: 12, md: 6, lg: 6, xl: 4, children: [_jsxs(Box, { className: classes.detailContainer, children: [_jsx(Box, { className: classes.detailLableContainer, children: _jsx(Typography, { component: "div", variant: 'h5', children: firstLabel }) }), _jsx(Box, { className: classes.detailValues, children: firstValue })] }), secondLabel &&
                _jsxs(Box, { className: classes.detailContainer, children: [_jsx(Box, { className: classes.detailLableContainer, children: _jsx(Typography, { component: "div", variant: 'h5', children: secondLabel }) }), _jsx(Box, { className: clsx((_b = {},
                                _b[classes.detailValueContainer] = true,
                                _b[classes.detailValues] = true,
                                _b)), children: secondValue })] })] }));
};
export default SeniorWellnessInfo;
